var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h3',{staticClass:"wb-type-heading-xs"},[_c('wb-counter',{staticClass:"wb-type-copy-secondary",attrs:{"value":_vm.count,"mode":"secondary"}}),_vm._v(" "+_vm._s(_vm.$t('schedule.bookingMatches.counter'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }